module.exports = __webpack_public_path__ + "static/img/PC-6.873fbe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/PC-6.png
// module id = 543g
// module chunks = 0